<template>
  <div class="value-input"
        data-input-type="numeric"
        data-input-name="name"
        :data-invalid="validComputed ? undefined : true"
        :data-input-value="value">
    <div class="field columns">
      <div class="field-label column">
        <label :data-tooltip="tooltip">{{title}}</label>
      </div>
      <div class="field-body column">
        <div class="control">
          <money class="input" v-bind="formatComputed" v-model="value"></money>
          <span v-if="subtitleComputed">{{ subtitleComputed }}</span>
        </div>
      </div>
    </div>
    <label  data-tooltip="Novicell optimisation and management fee.">

    </label>

  </div>
</template>
<script>
  import {Money} from 'v-money'
  import Tooltip from '../atoms/Tooltip'

  const moment = require('moment');

  export default {
    name: 'NumericValueInput',
    components: {
      Money,
      Tooltip
    },
    props: {
      name: String,
      validFn: Function,
      valid: Boolean,
      subtitleFn: Function,
      subtitle: String,
      title: String,
      tooltip: String,
      format: String,
      defaultValue: Number,
    },
    data () {
      return {
        value: this.defaultValue,
      }
    },
    watch: {
      value (newValue, oldValue) {
        this.$emit('input', newValue);
      }
    },
    created: function() {
      this.$emit('input', this.value);
    },
    computed: {
      formatComputed: function() {
        const formats = {
          money: {
            // The character used to show the decimal place.
            decimal: '.',
            // The character used to separate numbers in groups of three.
            thousands: ',',
            // The currency name or symbol followed by a space.
            prefix: '£ ',
            // The suffix (If a suffix is used by the target currency.)
            suffix: '',
            // Level of decimal precision. REQUIRED
            precision: 2,
            // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
            masked: false
          },
          moneyNoDecimal: {
            // The character used to show the decimal place.
            decimal: '.',
            // The character used to separate numbers in groups of three.
            thousands: ',',
            // The currency name or symbol followed by a space.
            prefix: '£ ',
            // The suffix (If a suffix is used by the target currency.)
            suffix: '',
            // Level of decimal precision. REQUIRED
            precision: 0,
            // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
            masked: false
          },
          percent: {
            // The character used to show the decimal place.
            decimal: '.',
            // The character used to separate numbers in groups of three.
            thousands: '',
            // The currency name or symbol followed by a space.
            prefix: '',
            // The suffix (If a suffix is used by the target currency.)
            suffix: '%',
            // Level of decimal precision. REQUIRED
            precision: 2,
            // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
            masked: false
          },
          percentNoDecimal: {
            // The character used to show the decimal place.
            decimal: '.',
            // The character used to separate numbers in groups of three.
            thousands: '',
            // The currency name or symbol followed by a space.
            prefix: '',
            // The suffix (If a suffix is used by the target currency.)
            suffix: '%',
            // Level of decimal precision. REQUIRED
            precision: 0,
            // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
            masked: false
          },
        };
        if(formats.hasOwnProperty(this.format)) {
          return formats[this.format];
        }
        console.warn("warning: NumericValueInput: `format` not recognised");
        return {};
      },
      validComputed() {
        return this.validFn && this.validFn(this.value) || this.valid;
      },
      subtitleComputed() {
        let x;
        if(this.subtitleFn && (x = this.subtitleFn(this.value, this.validComputed)) !== undefined)
            return x;
        return this.subtitle;
      }
    }
  }
</script>

<style scoped>

  [data-invalid] input {
    border: 2px solid red;
  }

</style>
